var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "75.477%",
    y1: "91.865%",
    x2: "23.301%",
    y2: "9.764%",
    id: "lee6pc79ia"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A48CF6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1C5FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-28.6%",
    y: "-51.9%",
    width: "157.1%",
    height: "203.9%",
    filterUnits: "objectBoundingBox",
    id: "a5m6iq0trb"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.548221331 0 0 0 0 0.422930959 0 0 0 0 0.976296769 0 0 0 0.37890625 0",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#lee6pc79ia)",
    cx: 21.5,
    cy: 21.5,
    r: 21.5
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#a5m6iq0trb)",
    transform: "translate(8 13)",
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m24.147 10.356.147.034 1.124.31a3.566 3.566 0 0 1 2.544 2.689c.107.492-.014 1-.33 1.392-.283.35-.687.568-1.13.612l-.166.009h-4.663l.03-.035a3.101 3.101 0 0 0 .624-2.612 5.58 5.58 0 0 0-1.124-2.327c.245.084.476.216.662.41a.53.53 0 0 0 .781.02c.4-.42.96-.6 1.5-.502zm-18.81.484c.235.246.579.228.78.017.195-.203.43-.34.679-.427a5.573 5.573 0 0 0-1.122 2.323 3.084 3.084 0 0 0 .621 2.613l.016.018.017.018H1.665c-.506 0-.979-.226-1.297-.62a1.65 1.65 0 0 1-.33-1.393 3.566 3.566 0 0 1 2.344-2.627l.2-.062 1.125-.31c.584-.163 1.21.01 1.63.45zm11.09-1.654.163.037 1.456.403a4.46 4.46 0 0 1 3.187 3.366c.028.14.044.28.044.426 0 .448-.15.885-.442 1.243a1.985 1.985 0 0 1-1.371.731l-.18.008H8.716c-.604 0-1.17-.269-1.55-.739a1.974 1.974 0 0 1-.398-1.669A4.46 4.46 0 0 1 9.746 9.69l.208-.063 1.456-.403c.7-.19 1.45.012 1.949.538a.863.863 0 0 0 1.26.022 1.985 1.985 0 0 1 1.809-.597zm5.836-5.904c1.635 0 2.968 1.584 2.968 3.539 0 1.949-1.333 3.533-2.968 3.533s-2.962-1.584-2.962-3.533c0-1.954 1.327-3.54 2.962-3.54zm-16.526 0C7.373 3.282 8.7 4.866 8.7 6.82c0 1.949-1.327 3.533-2.963 3.533-1.635 0-2.968-1.584-2.968-3.533 0-1.954 1.333-3.54 2.968-3.54zM13.997 0c2.033 0 3.685 1.988 3.685 4.43 0 2.436-1.652 4.424-3.685 4.424-2.027 0-3.679-1.988-3.679-4.424 0-2.442 1.652-4.43 3.68-4.43z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon-1.0dd99fab3d1bfeb38b9baf74f1783b8c.svg";
export { ForwardRef as ReactComponent };